module.exports = {"410721101":"翟坡镇","410721102":"小冀镇","410721103":"七里营镇","410721104":"朗公庙镇","410721105":"古固寨镇","410721107":"大召营镇","410721200":"合河乡","410721560":"新乡经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410721.json
// module id = 1707
// module chunks = 0